import { render } from "./tagQuery.vue?vue&type=template&id=6954b962&scoped=true"
import script from "./tagQuery.vue?vue&type=script&lang=js"
export * from "./tagQuery.vue?vue&type=script&lang=js"

import "./tagQuery.vue?vue&type=style&index=0&id=6954b962&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6954b962"

export default script